<div *ngIf="showToast" class="banner">
  <p>{{ message }}</p>
  <span class="banner_progress"></span>
</div>
